import OrganizationDto from '@/common/classes/dto/OrganizationDto'
import { ResponseStatuses } from '@/enums/ResponseStatuses'
import { ApiClient } from '@/helpers/api-client/ApiClient'

const cache = new Map()

export default class CheckOrganizationInn {
  /**
   * @param {OrganizationDto} organization
   * @returns {Promise<OrganizationDto>}
   */
  trigger(organization) {
    const inn = organization.inn
    if (!cache.has(inn)) {
      cache.set(inn, ApiClient.checkOrganizationInn({ inn }))
    }

    return cache.get(inn)
      .then(function(response) {
        const result = response.data
        const mixin = {}

        mixin.innError = false
        mixin.innHint = null
        if (result.status === ResponseStatuses.Fail) {
          mixin.innError = true
          mixin.innHint = result.message
        }

        return new OrganizationDto(Object.assign({}, organization, mixin))
      })
      .catch(() => Promise.resolve(organization))
  }
}
